import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangePhoneInstructionLazy = lazyLoader(
  () =>
    import(
      './ChangePhoneInstruction' /* webpackChunkName: "change-phone-instruction" */
    ),
);

const ChangePhoneInstruction = () => {
  return (
    <Suspense fallback={null}>
      <ChangePhoneInstructionLazy />
    </Suspense>
  );
};

export default ChangePhoneInstruction;
